import React, { Component } from 'react';
import $, { data } from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import DataTable from 'react-data-table-component';
import { tokenVerification } from './Utils';

class ServiceLine extends Component {
    constructor() {
        super();
        this.state = {
            dataStartedProcessing: false,
            dontOverLap: false,
            selectedHealthSystemId: '',
            selectedHospitalId: '',
            showLoader: false,
            healthSystemId: '',
            data: [{
                id: '',
                name: '',
                description: ''
            }],
            hideTextAreaPopup: false,
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit.svg',
            contentEditable: "false",
            hidden: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            successResp: false,
            pageNum: null,
            paginationValue: 10,
            healthSystemValue: [],
            hospitalGroupValue: [],
            disableSaveButton: false,
            topHeading: '',
            editedDescription: "",
            editedName: "",
            searchTerm: "",
            noMatchingData: false,
            isLoading: true,
            tableReady: false,

        }
        this.state.selectedHealthSystemId = localStorage.getItem('healthSystemId');
        this.state.selectedHospitalId = localStorage.getItem('hospitalId');
        this.setState(this.state);
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
        this.userDetails = JSON.parse(localStorage.getItem("user_details"));
        this.healthSystemDropDownInSLRef = React.createRef();
        this.hospitalDropDownInSLRef = React.createRef();
    }

    componentDidMount() {
        var thisController = this;
        const savedPage = localStorage.getItem("lastServiceLineActivePage");
        if (savedPage !== null) {
            thisController.restoredPage = parseInt(savedPage);
            localStorage.removeItem("lastServiceLineActivePage");
        } else {
            thisController.restoredPage = 1;
        }

        if (thisController.props.location.state != undefined) {
            thisController.state.pageNum = thisController.props.location.state.pageNum
            thisController.state.selectedHealthSystemId = thisController.props.location.state.healthSystemId;
            thisController.state.selectedHospitalId = thisController.props.location.state.hospitalId;
            thisController.setState(thisController.state);
        }
        thisController.fetchHealthSystemDetails();
    }

    fetchHealthSystemDetails() {
        var thisController = this;
        var responseData = [];
        $.ajax(
            {
                url: "/my-jeeva-api/health-system",

                method: 'GET',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                },
                success: function (res) {
                    if (res.success === true) {
                        thisController.state.showLoader = true;
                        thisController.setState(thisController.state);
                        responseData = res.result;
                        var totalCount = responseData.length;
                        thisController.state.healthSystemValue = [];
                        for (var i = 0; i < totalCount; i++) {
                            thisController.state.healthSystemValue.push(
                                { "name": res.result[i].name, "value": res.result[i].id });
                        }

                        thisController.setState(thisController.state);


                        if (!thisController.state.selectedHealthSystemId) {
                            var healthSystemsDropDownList = thisController.healthSystemDropDownInSLRef.current;
                            if (healthSystemsDropDownList) {
                                thisController.state.selectedHealthSystemId = healthSystemsDropDownList.value;
                                setTimeout(() => { thisController.onHealthSystemChange({ target: thisController.healthSystemDropDownInSLRef.current }) }, 100);
                            } else {
                                thisController.state.selectedHealthSystemId = res.result[0].id;
                                setTimeout(() => { thisController.onHealthSystemChange({ target: thisController.healthSystemDropDownInSLRef.current }) }, 100);
                            }
                        }
                        thisController.setState(thisController.state);
                        thisController.fetchHospitalDetails();

                    } else {
                        thisController.notifyFailedLoad(res.result);
                    }

                }, error: function (xhr, status, error) {
                    var errorMessage = xhr.status + ': ' + xhr.statusText
                    if (xhr.status == 401) {
                        tokenVerification();
                    }
                }
            }
        )

    }

    fetchHospitalDetails() {
        var thisController = this;
        var responseData = [];
        var healthSystemId;
        var userRole = this.userDetails["userRole"];
        if (userRole == 'HOSPITAL_ADMIN' || userRole == 'SERVICELINE_ADMIN') {
            healthSystemId = this.userDetails["healthSystemId"];
        } else {
            healthSystemId = thisController.state.selectedHealthSystemId;

        }
        $.ajax(
            {
                url: "/my-jeeva-api/hospital",

                method: 'GET',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                }, data: {
                    healthSystemId: healthSystemId
                },
                success: function (res) {
                    if (res.success === true) {
                        thisController.state.showLoader = true;
                        thisController.setState(thisController.state);
                        responseData = res.result;
                        var totalCount = responseData.length;
                        thisController.state.hospitalGroupValue = [];
                        for (var i = 0; i < totalCount; i++) {
                            thisController.state.hospitalGroupValue.push(
                                {
                                    "name": res.result[i].name,
                                    "value": res.result[i].id
                                });
                        }

                        thisController.setState(thisController.state);
                        if (!thisController.state.selectedHospitalId) {
                            if (totalCount > 0) {
                                thisController.state.selectedHospitalId = res.result[0].id;
                                setTimeout(() => { thisController.onHospitalChange({ target: thisController.hospitalDropDownInSLRef.current }) }, 100);
                            }
                        }
                        thisController.setState(thisController.state);
                        thisController.fetchServiceLineDetails();
                    } else {
                        thisController.notifyFailedLoad(res.result);
                    }
                }, error: function (xhr, status, error) {
                    var errorMessage = xhr.status + ': ' + xhr.statusText
                    if (xhr.status == 401) {
                        tokenVerification();
                    }
                }
            }
        )

    }

    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There are no service lines present. </p>
        </div>
    );

    fetchServiceLineDetails = () => {
        var userRole = this.userDetails["userRole"];
        var healthSystemId;
        var hospitalId;
        var fetchController = this;
        if (userRole == 'HEALTHSYSTEM_ADMIN') {
            healthSystemId = this.userDetails["healthSystemId"];
            hospitalId = fetchController.state.selectedHospitalId;
        }
        else if (userRole == 'HOSPITAL_ADMIN') {
            healthSystemId = this.userDetails["healthSystemId"];
            hospitalId = this.userDetails["hospitalId"];
        } else {
            healthSystemId = fetchController.state.selectedHealthSystemId;
            hospitalId = fetchController.state.selectedHospitalId;
        }
        if (hospitalId == "null") {
            hospitalId = "00000000-0000-0000-0000-000000000000";
        }

        $.ajax({
            url: "/my-jeeva-api/service-line",

            method: 'GET',
            headers: {

                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                healthSystemId: healthSystemId,
                hospitalId: hospitalId
            },
            success: function (res) {
                if (res.success === true) {
                    fetchController.state.data = res.result;
                    fetchController.state.disabled = false;
                    fetchController.state.noMatchingData = false;
                    fetchController.state.isLoading = false;
                    fetchController.state.showLoader = true;
                    fetchController.state.pageNum = fetchController.restoredPage || 1;
                    fetchController.state.tableReady = true;
                    fetchController.setState(fetchController.state);

                } else {
                    // fetchController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        });

    }
    saveServiceLineDetails(row, e) {
        var thisController = this;
        var userRole = this.userDetails["userRole"];
        var healthSystemId;
        var hospitalId;
        thisController.disableSaveButton = true;
        thisController.setState(thisController.state);

        if (userRole == 'HEALTHSYSTEM_ADMIN') {
            healthSystemId = this.userDetails["healthSystemId"];
            hospitalId = document.getElementById("hospitalDropDownInSL").value;
        }
        else if (userRole == 'HOSPITAL_ADMIN') {
            healthSystemId = this.userDetails["healthSystemId"];
            hospitalId = this.userDetails["hospitalId"];
        } else {
            healthSystemId = thisController.state.selectedHealthSystemId;
            hospitalId = thisController.state.selectedHospitalId;
        }
        if (healthSystemId == 'Select Health System') {
            thisController.notifySelectHealthSystem();
        } else if (hospitalId == 'null' || hospitalId == null) {
            thisController.notifySelectHospital();
        }
        else {
            var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);
            row.name = document.getElementById("name" + row.id).innerText.trim() || thisController.state.editedName.trim();
            row.description = document.getElementById("description" + row.id).innerText.trim() || thisController.state.editedDescription.trim();
            if (row.name == "") {
                thisController.notifyMsgFieldEmpty();
            } else if (!namePattern.test(row.name)) {
                thisController.notifyImproperName();
            } else {
                thisController.state.editedId = "-1";
                thisController.state.dataStartedProcessing = true;
                thisController.setState(thisController.state);
                var saveData = {
                    name: row.name,
                    description: row.description,
                    healthSystemId: healthSystemId,
                    hospitalId: hospitalId
                }

                var timer = setInterval(function () {
                    clearTimeout(timer);

                    $.ajax({
                        url: "/my-jeeva-api/service-line",
                        method: 'POST',
                        headers: {
                            'Authorization': "Bearer " + localStorage.getItem("access_token"),
                            'Content-Type': "application/json",

                        },
                        data: JSON.stringify(saveData),
                        success: function (res) {
                            if (res.success === true) {
                                thisController.state.dataStartedProcessing = false;
                                thisController.state.disableSaveButton = false;
                                thisController.setState(thisController.state);
                                thisController.fetchServiceLineDetails();
                                thisController.setState({ disabled: false })
                            } else {
                                thisController.notifyFailed(res.result);
                            }
                        },
                        error: function (xhr) {
                            if (xhr.status == 401) {
                                window.location.href = "";
                            }
                        }
                    })

                }, 2000);

            }
        }
    }
    updateServicelineDetailsApi = (row) => {
        var thisController = this;
        var userRole = this.userDetails["userRole"];
        var healthSystemId;
        var hospitalId;

        if (userRole == 'HEALTHSYSTEM_ADMIN') {
            healthSystemId = this.userDetails["healthSystemId"];
            hospitalId = document.getElementById("hospitalDropDownInSL").value;
        }
        else if (userRole == 'HOSPITAL_ADMIN') {
            healthSystemId = this.userDetails["healthSystemId"];
            hospitalId = this.userDetails["hospitalId"];
        } else {
            healthSystemId = document.getElementById('healthSystem').value;
            hospitalId = document.getElementById("hospitalDropDownInSL").value;
        }

        if (healthSystemId == 'Select Health System') {
            thisController.notifySelectHealthSystem();
        } else if (hospitalId == 'Select Hospital') {
            thisController.notifySelectHospital();
        }
        else {
            var editedDescription = thisController.state.editedDescription;
            var editedName = thisController.state.editedName;
            // var editedDescription = thisController.editedDescriptionRef.current.innerText.trim();
            // var editedName = thisController.editedNameRef.current.innerText.trim();
            var updateController = this;
            var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);

            if (editedName == "") {
                updateController.notifyMsgFieldEmpty();
            } else if (!namePattern.test(editedName)) {
                updateController.notifyImproperName();
            } else {
                updateController.state.disableSaveButton = true;
                updateController.setState(updateController.state);
                var updatedData = {
                    id: row.id,
                    name: editedName,
                    description: editedDescription,
                    healthSystemId: healthSystemId,
                    hospitalId: hospitalId
                };
                $.ajax({
                    url: "/my-jeeva-api/service-line",

                    method: 'PATCH',
                    headers: {
                        'Authorization': "Bearer " + localStorage.getItem("access_token"),
                        'Content-Type': 'application/json',
                    },
                    data: JSON.stringify(updatedData),
                    contentType: "application/json; charset=UTF-8",
                    success: function (res) {
                        if (res.success === true) {
                            updateController.state.editedId = "-1";
                            updateController.state.disableSaveButton = false;
                            updateController.setState(updateController.state);
                            updateController.fetchServiceLineDetails();
                        } else {
                            updateController.notifyFailed(res.result);
                        }
                    },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            window.location.href = "";
                        }
                    }


                })
            }
        }

    }
    notifyImproperName() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid name</b>, {
            position: "top-center"
        });
    }

    notifyFailedLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red",
        });
    }

    deleteServiceLineDetails = (id) => {
        let serviceLineData = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            serviceLineData.splice(id, 1);
        } else {
            $.ajax({
                url: "/my-jeeva-api/delete-service-line/" + id,

                method: 'DELETE',
                headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        serviceLineData.splice(id, 1);
                        deleteApiViewController.refreshData();
                    } else {
                        // serviceLineData.notifyError();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }
            });
        }

        if (this.state.deleteRow) {
            this.state.data.splice(id, 1);
        }
        deleteConstructorVariables.fetchServiceLineDetails();


    }

    notifyDataProcessing() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;Hold on.Your data is saving...
            </b>,
            {
                position: "top-center",
            }
        );
    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields before saving</b>, {
            position: "top-center"
        });

    }

    notifyWorkInProgress() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;This is a Work in Progress Feature</b>, {
            position: "top-center"
        });
    }


    addNewServiceLine = () => {
        var thisController = this;
        thisController.state.paginationValue = thisController.state.paginationValue + 5;
        if (thisController.state.pageNum != 0) {
            thisController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            id: "",
            name: "",
            description: "",
        });
        this.setState({
            noMatchingData: false,
            data: this.state.data,
            disabled: true,
            editedDescription: "",
            editedName: ""
        })
    }

    notifySelectHealthSystem() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Please Select Health System</b>, {
            position: "top-center"
        });
    }

    notifySelectHospital() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Please Select Hospital before creating service line</b>, {
            position: "top-center"
        });
    }

    makeCelledit(row, e) {
        this.markAsBeingEdited(row.id);
        this.state.editedName = row.name;
        this.state.editedDescription = row.description;
        this.setState(this.state);
    }

    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }
    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }

    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.setState({
            isLoading: true,
            disabled: false,
            data: [],
            searchTerm: "",
        });
        this.fetchServiceLineDetails();
    }

    notifyServiceLineAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg"
            style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;Service Line added successfully</b>, {
            position: "top-center",
        });
    }


    notifyUpdate() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Service Line details updated successfully</b>, {
            position: "top-center",
        });
    }

    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Service Line Detail deleted successfully</b>, {
            position: "top-center",
        });
    }
    notifyEmptyFields() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields before saving</b>, {
            position: "top-center"
        });
    }




    notifyFailed(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    onPageChange = (e) => {
        this.restoredPage = e;
        this.setState({ pageNum: e })
        localStorage.setItem("lastServiceLineActivePage", e);
    }



    notifyFailedDelete(response) {
        toast.dismiss();
        toast(<b><img src="/my-jeeva/assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;{response}</b>, {
            position: "top-center"
        });

    }



    handleChangeForLanguage = (event) => {
        this.setState({
            value: event.target.value,
        });
        this.fetchServiceLineDetails();
    }
    addAdmin = (row, e) => {
        const pageToSave = this.state.pageNum || 1;
        localStorage.setItem("lastServiceLineActivePage", pageToSave);
        var userRole = this.userDetails["userRole"];
        var healthSystemId;
        var hospitalId;
        if (userRole == 'HEALTHSYSTEM_ADMIN') {
            healthSystemId = this.userDetails["healthSystemId"]
            hospitalId = document.getElementById("hospitalDropDownInSL").value;

        }
        else if (userRole == 'HOSPITAL_ADMIN') {
            healthSystemId = this.userDetails["healthSystemId"];
            hospitalId = this.userDetails["hospitalId"];
        } else {
            healthSystemId = document.getElementById('healthSystem').value;
            hospitalId = document.getElementById("hospitalDropDownInSL").value;
        }

        this.props.history.push({
            pathname: '/projectmgmt/service-line-admin',
            state: {
                serviceLineId: row.id,
                healthSystemId: healthSystemId,
                hospitalId: hospitalId
            }
        });
        this.setState(this.setState)
    }

    onHealthSystemChange = (e) => {
        var selectBox = e.target;
        if (!selectBox) {
            console.warn("Health system dropdown ref is not available");
            return;
        }
        this.state.dontOverLap = true;
        this.state.isLoading = true;
        if (this.state.selectedHealthSystemId != selectBox.value) {
            this.state.selectedHospitalId = null;
            localStorage.setItem(`hospitalName`, null);
            localStorage.setItem("serviceName", null);
        }
        this.state.selectedHealthSystemId = selectBox.value;
        localStorage.setItem('healthSystemId', this.state.selectedHealthSystemId);
        if (selectBox.value != "") {
            localStorage.setItem('healthSystemName', selectBox.options[selectBox.selectedIndex].innerText);

        }

        this.setState(this.state);
        window.adminNavigationBar.paintHeading();
        this.fetchHospitalDetails();

    }
    onHospitalChange = (e) => {
        var selectBox = e.target;
        if (!selectBox) return;
        this.state.isLoading = true;
        if (this.state.selectedHospitalId != selectBox.value) {
            this.state.serviceLineId = null;
            localStorage.setItem(`hospitalName`, null);
            localStorage.setItem('serviceName', null);
        }
        this.state.selectedHospitalId = selectBox.value;
        localStorage.setItem('hospitalId', this.state.selectedHospitalId);
        if (selectBox.value != "") {
            localStorage.setItem('hospitalName', selectBox.options[selectBox.selectedIndex].innerText);
        }
        this.setState(this.state);
        window.adminNavigationBar.paintHeading();
        this.fetchServiceLineDetails();
    }

    navigateToLibrary(serviceLine, serviceLineId) {
        this.props.history.push({
            pathname: '/projectmgmt/service-line-content-library',
            state: {
                serviceLine: serviceLine,
                serviceLineId: serviceLineId,
                healthSystemId: this.state.selectedHealthSystemId,
                hospitalId: this.state.selectedHospitalId
            }
        });
    }
    handleAnchor = (id, name) => {
        window.adminNavigationBar.markActiveTab();
        localStorage.setItem(`serviceLineId`, id);
        localStorage.setItem(`serviceName`, name);
    }
    openDeletePopUp = (row) => {

        confirmAlert({
            title: 'Confirm to Delete',
            message: `Are you sure you want to delete ${row.name} ?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.deleteServiceLineDetails(row.id)
                },
                {
                    label: 'No',
                }
            ]
        });
    }

    handleDescriptionChange = (e) => {
        this.state.editedDescription = e.currentTarget.textContent.trim();
        this.setState(this.state);
    }
    handleNameChange = (e) => {
        this.state.editedName = e.currentTarget.textContent.trim();
        this.setState(this.state);
    }

    caseInsensitiveSort = (field) => (rowA, rowB) => {
        const a = rowA[field] ? rowA[field].toLowerCase() : '';
        const b = rowB[field] ? rowB[field].toLowerCase() : '';

        if (a > b) {
            return 1;
        }

        if (b > a) {
            return -1;
        }

        return 0;
    };

    handleSearch = (event) => {
        var thisController = this;
        thisController.state.searchTerm = event.target.value;
        thisController.state.isLoading = true;
        thisController.state.data = [];
        thisController.setState(thisController.state);

        var userRole = this.userDetails["userRole"];
        var healthSystemId;
        var hospitalId;
        if (userRole == 'HEALTHSYSTEM_ADMIN') {
            healthSystemId = this.userDetails["healthSystemId"];
            hospitalId = thisController.state.selectedHospitalId;
        }
        else if (userRole == 'HOSPITAL_ADMIN') {
            healthSystemId = this.userDetails["healthSystemId"];
            hospitalId = this.userDetails["hospitalId"];
        } else {
            healthSystemId = thisController.state.selectedHealthSystemId;
            hospitalId = thisController.state.selectedHospitalId;
        }
        if (hospitalId == "null") {
            hospitalId = "00000000-0000-0000-0000-000000000000";
        }

        $.ajax({
            url: "/my-jeeva-api/search-service-line-data",
            method: "GET",
            data: {
                healthSystemId: healthSystemId,
                hospitalId: hospitalId,
                searchTerm: thisController.state.searchTerm
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        thisController.state.data = [];
                        thisController.setState(thisController.state);
                        thisController.state.noMatchingData = false;
                        thisController.state.isLoading = false;
                        thisController.state.data = res.result;
                        thisController.setState(thisController.state);
                    } else {
                        thisController.state.noMatchingData = true;
                        thisController.state.isLoading = false;
                        thisController.setState(thisController.state);
                    }
                }
            },
            error: function (xhr) {

            },
        });

    };

    clearSearchData = () => {
        var thisController = this;
        thisController.setState({ searchTerm: "" }, () => {
            thisController.fetchHealthSystemDetails();
        });
    }

    render() {
        const columns = [
            {
                name: <b style={{ fontSize: '16px' }}> Name</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('name'),
                selector: (row) => (
                    <div name="name">
                        <a href={row.id == "" || row.id == this.state.editedId ? "javascript:void(0)" : "/my-jeeva/projectmgmt/procedure"} style={{
                            cursor: row.id == "" || row.id == this.state.editedId ? "default" : 'pointer'
                        }}
                            onClick={() => row.id == "" || row.id == this.state.editedId ? "" : this.handleAnchor(row.id, row.name)}>

                            <div className="textarea"
                                style={{
                                    background: 'white', height: "2.7em", resize: 'none',
                                    paddingLeft: '2px', paddingTop: '6px',
                                    border: (row.id == "" || row.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                                    borderRadius: (row.id == "") ? '2px' : 'none'
                                }}
                                onInput={(e) => { this.handleNameChange(e) }}
                                id={"name" + row.id}
                                // ref={this.editedNameRef}
                                contentEditable={!((row.id == "") ? false :
                                    row.id != this.state.editedId) ? "plaintext-only" : false}
                            >{row.name}
                            </div>
                        </a>
                    </div>)
            },
            {
                name: <b style={{ fontSize: '16px' }}>Description</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('description'),
                selector: (row) => (
                    <div name="description">
                        <div className="textarea"
                            style={{
                                background: 'white', height: "2.7em", resize: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (row.id == "" || row.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                                borderRadius: (row.id == "") ? '2px' : 'none', overflowY: "scroll"
                            }}
                            onInput={(e) => { this.handleDescriptionChange(e) }}
                            id={"description" + row.id}
                            // ref={this.editedDescriptionRef}
                            contentEditable={!((row.id == "") ? false :
                                row.id != this.state.editedId) ? "plaintext-only" : false}
                        >{row.description}
                        </div>
                    </div>)
            },

            {
                name: <b style={{ fontSize: '16px' }}> Actions</b>,
                width: "200px",
                selector: (row) => (
                    <div id="action">
                        <button style={{ backgroundColor: "#ffffff", border: "none", marginLeft: '-6px' }} disabled={this.state.disableSaveButton}>
                            <img className="img-responsive"
                                title={(row.id == "") ||
                                    (row.id == this.state.editedId) ? 'Save' : 'Edit'}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                src={(row.id == "") ? this.saveImageSrc : ((row.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    this.state.dataStartedProcessing
                                        ? this.notifyDataProcessing() :
                                        (row.id == "") ? this.saveServiceLineDetails(row, e) : (row.id == this.state.editedId) ?
                                            this.updateServicelineDetailsApi(row, e) : this.makeCelledit(row, e);
                                }} />
                        </button>

                        <button style={{
                            backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px'
                        }} title="Delete">
                            <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                onClick={() => (row.id) === '' ?
                                    this.fetchServiceLineDetails() :
                                    this.openDeletePopUp(row)}
                            // this.setState({
                            //     hideDeletePopup: true, propsId: row.id
                            // })}
                            />
                        </button>

                        <button style={{
                            backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px'
                        }} title="Admin" onClick={(e) => { this.addAdmin(row, e) }}>
                            <img className="img-responsive" src={"./assets/images/admin.png"}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                            />
                        </button>

                        {/* <button className="btn action-button" style={{ padding: '0vw', width: '6vw', height: '27px', marginTop: '-1vw' }}
                            title="Library" onClick={() => {
                                this.navigateToLibrary(props.original.name, props.original.id);
                            }} >Library</button> */}
                    </div>), width: "135px"
            },
        ]
        return (
            <div id='serviceLineTab' style={{ marginRight: '1%' }}>
                {/* <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!(this.state.showLoader)}
                    height={400}
                    width={50}
                    style={{ textAlign: 'center' }} /> */}
                <div style={{ background: "#F9F9FB", display: this.state.showLoader ? 'block' : 'none' }} >
                    {/* for toaster */}
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    {/*for dialog component */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | BackEnd Api </title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    {/* <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" /> */}
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    {/* <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" /> */}
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />
                    <link rel="stylesheet" href="./assets/css/styles.css" />

                    <div className="row" style={{ marginLeft: "15px" }}>
                        <div className="col-sm-4" style={{ marginTop: '2px' }} >

                        </div>
                    </div>

                    <div className="row" style={{ marginLeft: '14px' }}>
                        <div className='col-sm-2'>
                            <h6 className="nav-item" style={{ color: '#282a65', marginTop: '1vh' }}>
                                Service Line</h6>
                        </div>
                        <div className='col-sm-8' Align='right' style={{ marginLeft: "-20vw" }}>
                            <label style={{ display: (window.SCOPE_VALUE.CURRENT > window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN) ? 'inline' : 'none' }}>Health System</label>

                            <select
                                value={this.state.selectedHealthSystemId}
                                id="healthSystem" className="healthSystem"
                                onChange={(e) => this.onHealthSystemChange(e)} placeholder="Select Health System"
                                ref={this.healthSystemDropDownInSLRef}
                                style={{
                                    display: (window.SCOPE_VALUE.CURRENT > window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN) ? 'inline' : 'none',

                                    height: '30px', borderRadius: '4px',
                                    backgroundColor: '#F9F9FB', width: '13vw', marginLeft: '10px'
                                }}>
                                {this.state.healthSystemValue.map((healthSystem) =>
                                    <option value={healthSystem.value}>{healthSystem.name}</option>)}

                            </select>

                            <label style={{
                                marginLeft: '5vh',
                                display: (window.SCOPE_VALUE.CURRENT > window.SCOPE_VALUE.HOSPITAL_ADMIN)
                                    ? 'inline' : 'none'
                            }} >Hospital</label>


                            <select
                                value={this.state.selectedHospitalId}
                                id="hospitalDropDownInSL" className="hospital"
                                onChange={(e) => this.onHospitalChange(e)} placeholder="Select hospital"
                                ref={this.hospitalDropDownInSLRef}
                                style={{
                                    display: (window.SCOPE_VALUE.CURRENT > window.SCOPE_VALUE.HOSPITAL_ADMIN)
                                        ? 'inline' : 'none',
                                    height: '30px', borderRadius: '4px',
                                    backgroundColor: '#F9F9FB', width: '13vw', marginLeft: '10px'
                                }}>
                                {this.state.hospitalGroupValue.map((hospitalGroup) =>
                                    <option value={hospitalGroup.value}>{hospitalGroup.name}</option>)}

                            </select>
                        </div>
                        <div
                            style={{ marginLeft: "2vw",
                            //  marginTop: "-0.4vh"
                              }}>
                            <input
                                type="text"
                                style={{
                                    width: "10vw",
                                    border: "1px solid #777676",
                                    borderRadius: "3px",
                                    padding: "10px",
                                    height: "0.6vw",
                                    paddingRight: "2rem",
                                  }}
                                value={this.state.searchTerm}
                                onChange={this.handleSearch}
                                placeholder="Search ..."
                            />
                            {this.state.searchTerm && (
                                <span
                                    onClick={() => this.clearSearchData()}
                                    style={{
                                        // position: "absolute",
                                        right: "8px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "#777676",
                                        fontSize: "1.2rem",
                                        fontWeight: "bold",
                                        lineHeight: 1,
                                        userSelect: "none",
                                        marginLeft: "-1vw"
                                    }}
                                >
                                    ×
                                </span>
                            )}
                        </div>
                        <div className="col-sm-2 " style={{ marginTop: '-30px' }}>
                            <div className="d-flex flex-row-reverse pt-2">

                                <div className="p-2" style={{ marginBottom: '10px' }}>

                                    <button className="btn action-button"
                                        id="addMsg" title=" Add "
                                        onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addNewServiceLine}>
                                        <img src="assets/images/add_white_24dp.png" />
                                    </button>
                                    <button title="Refresh" onClick={this.refreshData} type="button" className="btn action-button">
                                        <img src="./assets/images/refresh_white_24dp.png"></img></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{ marginLeft: '15px', marginTop: '-5px' }}>
                        <div className="col-lg-12 ">
                            {!this.state.noMatchingData &&
                                <div className="card">
                                    {this.state.isLoading && (
                                        <div style={{ padding: '20px', textAlign: 'center' }}>
                                            <p>Loading ...</p>
                                        </div>
                                    )}
                                    {!this.state.isLoading && this.state.data.length === 0 && (
                                        <div style={{ padding: '20px', textAlign: 'center' }}>
                                            <p>There are no service lines present.</p>
                                        </div>
                                    )}
                                    {(!this.state.isLoading && this.state.data.length > 0) && (

                                        <DataTable
                                            data={this.state.data}
                                            columns={columns}
                                            pagination={this.state.paginationValue}
                                            key={"table-" + this.state.pageNum}
                                            onChangePage={this.onPageChange}
                                            paginationDefaultPage={this.state.pageNum || 1}
                                            defaultPageSize={10}
                                            pageSizeOptions={[5, 10, 15]}
                                            fixedHeaderScrollHeight="400px"
                                            noDataComponent={<this.CustomNoDataComponent />}
                                        />)}
                                </div>
                            }

                            <ToastContainer className="Toast-at-center" />

                            {/*Dialog Component For Deletion Confirmation*/}
                            {/* <DialogComponent width='400px' animationSettings={this.settings}
                                header='Delete Confirmation' showCloseIcon={true} buttons={this.buttons}
                                ref={dialog => this.dialogInstance = dialog} target='#serviceLineTab'
                                visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                    content="" />&nbsp;&nbsp;&nbsp;&nbsp;Do you want to delete this Service Line Detail?
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to delete or press 'No' to decline.
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</DialogComponent> */}

                        </div>
                    </div>
                    <div className='card'>
                        {this.state.noMatchingData &&
                            <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                                <p>No matching options found ...</p>
                            </div>
                        }
                    </div>
                </div>
            </div >
        )
    }
}

export default ServiceLine;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ServiceLine.js